import axiosClientGame from "../../api/axiosClientGame";
import customNotification from "../../components/notification";

const leaderBoardModel = {
  state: {
    leaderboardData: [],
    userDetailsView: {},
    winnerPlayersData: {},
    leaderboardConfig: {},
    pageData: {
        page: "0",
        perpage: "100",
        is_download: "0",
        IsBlock: false,
        search: '',
      },
  },
  reducers: {
    setData(state, payload) {
        return { ...state, [payload.name]: payload.data };
    },
    setPageData(state, payload) {
      return { ...state, pageData: payload };
    },
  },

  effects: (dispatch) => ({
    async getLeaderBoardData(_, state) {
      const payload = state.leaderBoardModel.pageData;
      await axiosClientGame
        .post("/leaderboardSearch",payload)
        .then((res) => {
          if (res.data.status === 200) {
            if (res.data.data.length === 0 && res.data.count > 0) {
              this.setPageData({ ...payload, page: `${+payload.page - 1}` });
              this.getLeaderBoardData();
              return;
            }
            this.setData({ name: "leaderboardData", data: res.data });
          } else if (payload.is_download == 1) {
            window.open(res.data.path, "_self");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() =>{
            this.setPageData({...payload,is_download:'0'})
        })
    },
    async addViewLeaderBoard(payload) {
      await axiosClientGame
        .post("/leaderboard", payload)
        .then((res) => {
          if (res.data.status === 200) {
            this.getLeaderBoardData();
            customNotification(res.data.message, "success");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() => {
          dispatch.modalModel.setModalData();
        });
    },
    async deleteViewLeaderBoard(payload) {
      await axiosClientGame
        .delete("/leaderboard", { data: payload })
        .then((res) => {
          if (res.data.status === 200) {
            this.getLeaderBoardData();
            customNotification(res.data.message, "success");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() => {
          dispatch.modalModel.setModalData();
        });
    },
    async getUserView(query, state) {
      const payload = state.leaderBoardModel.pageData;
      const { leaderboardId } = query;
      await axiosClientGame
        .get(`/leaderboard/${leaderboardId}`,{})
        .then((res) => {
          if (res.data.status === 200) {
            this.setData({ name: "userDetailsView", data: res.data.data });
          } else if (payload.is_download == 1) {
            window.open(res.data.path, "_self");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() =>{
            // this.setPageData({...payload,is_download:'0'})
        })
    },
    async updateUserView(payload) {
      await axiosClientGame
        .put("/leaderboard", payload)
        .then((res) => {
          if (res.data.status === 200) {
            this.getLeaderBoardData();
            customNotification(res.data.message, "success");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() => {
          dispatch.modalModel.setModalData();
        });
    },
    async getWinnerPlayers(query, state) {
      const payload = state.leaderBoardModel.pageData;
      const { leaderboardId } = query;
      await axiosClientGame
        .get(`/leaderboardPlayer/${leaderboardId}`,{})
        .then((res) => {
          if (res.data.status === 200) {
            this.setData({ name: "winnerPlayersData", data: res.data.data });
          } else if (payload.is_download == 1) {
            window.open(res.data.path, "_self");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() =>{
            // this.setPageData({...payload,is_download:'0'})
        })
    },
    async getLeaderboardConfig(_, state) {
      await axiosClientGame
        .get("/leaderboardConfig", {})
        .then((res) => {
          if (res.data.status === 200) {
            this.setData({ name: "leaderboardConfig", data: res.data.data });
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() =>{
            // this.setPageData({...payload,is_download:'0'})
        })
    },
    async updateConfigUser(payload) {
      await axiosClientGame
        .put("/leaderboardConfig", payload)
        .then((res) => {
          if (res.data.status === 200) {
            this.getLeaderboardConfig();
            customNotification(res.data.message, "success");
          } else {
            customNotification(res.data.message, "info");
          }
        })
        .catch((err) => {
          customNotification(err.message, "error");
        })
        .finally(() => {
          dispatch.modalModel.setModalData();
        });
    },
  }),
};
export default leaderBoardModel